<template>
  <div ref="animation" class="animation" />
</template>

<script>
import lottie from "lottie-web";

import getAnimation from "../helpers/getAnimation";

export default {
  props: {
    animation: {
      type: String
    },
    loop: {
      default: true,
      type: Boolean
    },
    speed: {
      default: 1,
      type: Number
    },
    play: {
      default: false,
      type: Boolean
    }
  },
  computed: {
    animationData() {
      return getAnimation(this.animation, this.mode);
    }
  },
  methods: {
    complete() {
      this.anim.stop();
      this.$emit("complete");
    }
  },
  watch: {
    play(value) {
      if (value && !this.loop) {
        this.anim.play();
      }
    }
  },
  mounted() {
    this.anim = lottie.loadAnimation({
      renderer: "svg",
      loop: this.loop,
      container: this.$refs.animation,
      animationData: this.animationData,
      autoplay: this.loop
    });
    this.anim.setSubframe(!this.loop);
    this.anim.setSpeed(this.speed);
    this.anim.onComplete = this.complete;

    if (this.play) {
      this.anim.play();
    }
  }
};
</script>

<style lang="scss" scoped>
.animation {
  height: 100%;
}
</style>
